export const defaultNiceDayForm = {
  tempRange: [55, 85],
  maxPrecip: 0.01,
  minSunshineDuration: 2,
};

export const defaultQueryForm = {
  city: undefined,
  compareCity: undefined,
  year: "2022",
};

export const maxNiceDaysInMonth = 31; // number of days in longest month

export const defaultMonthNiceDays = {
  January: [],
  February: [],
  March: [],
  April: [],
  May: [],
  June: [],
  July: [],
  August: [],
  September: [],
  October: [],
  November: [],
  December: [],
};

export const wikiUrl = "https://en.wikipedia.org/wiki/";

export const firstCityColor = "#3350e0";
export const compareCityColor = "#129614";
export const sunColor = "#ffdf22";
export const thermostatRedColor = "#e1252c";

export const defaultDailyVariables = [
  "apparent_temperature_max",
  "apparent_temperature_min",
  "sunshine_duration",
  "rain_sum",
  "precipitation_hours",
];

export const SELECT_OPTION_HEIGHT = 50;
